import { Article } from '@/types/Article'

export const mapApiArticleToPrisma = (articles: Article[]) => {
  return articles.map((article) => {
    return {
      ...article,
      published_date: new Date(article.published_date!),
      created_at: new Date(article.created_at!),
    }
  })
}
